import { createContext, useState, useMemo } from 'react';
import { ThemeProvider } from 'styled-components';
import get from 'lodash.get';
import { KarlsbaderFontFace } from './typography/KarlsbaderFontFace.js';
import { getTheme } from './themes.js';
import { ThemeVariables } from './ThemeVariables/index.js';
import { jsx, jsxs } from 'react/jsx-runtime';

var TetrisThemeContext = /*#__PURE__*/createContext(null);
function TetrisThemeProvider(props) {
  var children = props.children,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'light' : _props$theme;
  var _useState = useState(theme),
    themeType = _useState[0],
    setThemeType = _useState[1];
  var activeTheme = useMemo(function () {
    return getTheme(themeType);
  }, [themeType]);
  var themeGet = function themeGet(path) {
    return get(activeTheme, path);
  };
  var value = {
    themeGet: themeGet,
    themeType: themeType,
    setThemeType: setThemeType
  };
  var currentTheme = getTheme(themeType);
  return /*#__PURE__*/jsx(TetrisThemeContext.Provider, {
    value: value,
    children: /*#__PURE__*/jsxs(ThemeProvider, {
      theme: currentTheme,
      children: [/*#__PURE__*/jsx(ThemeVariables, {
        $theme: currentTheme
      }), /*#__PURE__*/jsx(KarlsbaderFontFace, {}), children]
    })
  });
}

export { TetrisThemeContext, TetrisThemeProvider };
